import {AfterViewInit, Component, NgZone, OnInit} from '@angular/core';
import {Router, RouterLink, ActivatedRoute} from '@angular/router';
import {UserService} from "../../service/user.service";

declare var $: any;
import * as _ from 'lodash';
import {HttpService} from "../../service/http.service";
import {PostFilterService} from "../../service/post-filter.service"
import {eventEmitterService} from "../../service/eventEmitter.service";
import {BuildingsService} from "../../service/buildings.service";
import {UserInfoService} from '../../service/user-info.service';
import {GroupService} from '../../service/group.service';
import {environment} from "../../../environments/environment";
import { Observable, timer } from 'rxjs';


@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.css']
})
export class SidemenuComponent implements OnInit, AfterViewInit {

  buildingAlertLink = '/buildings/alerts';
  // Get current loggedIn user ID
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userType = localStorage.getItem('type');
  userBuildingId = localStorage.getItem('userBuildingId');
  currentBuildingMaintenanceActive = localStorage.getItem('currentBuildingMaintenanceActive') == 'true';
  isManagerStatus = false;
  timer;
  alertNotificationTimer;
  unreadAlert = 0;
  oldUnreadAlert = 0;

  typeToFilter;

  totalMsg = 0;
  totalGroups = 0;
  docuTrue;
  alertTrue;
  alertList = [];
  isUser: any;
  totalGroupMsg;

  groupList = [];
  allGroups = [];
  leavingGroupName;
  s3apiUrl = environment.s3BucketApi;


  constructor(private userService: UserService,
              private ngZone: NgZone,
              private router: Router,
              private httpService: HttpService,
              private postFilter: PostFilterService,
              private buildingService: BuildingsService,
              private eventService: eventEmitterService,
              private route: ActivatedRoute, private link: PostFilterService,
              private userInfo: UserInfoService,
              private _groupService: GroupService,) {
  }

  ngOnInit() {

    // Updates unread alert count if a new alert is created
    this.eventService.alert$.subscribe((data) => {
      // console.log(data);
      if (data === 'reset') {
        setTimeout(() => {
          this.unreadAlert = 0;
          this.oldUnreadAlert = 0;
          this.alertList = []
        }, 1000)
      }
    });

    this.userInfo.isManager.subscribe((data: any) => {
      this.isManagerStatus = data;
    });

    self["io"].socket.on('activityfeed', (feeds) => {
      if (this.isManager !== 'true' && this.id && feeds && feeds.data && feeds.data.alerts) {
        this.alertList.push(feeds.data.alerts);
        this.unreadAlert = this.alertList.length + this.oldUnreadAlert;
        this.oldUnreadAlert = 0;
      }
    });

    $(window).ready(function () {
      $('.feed').click(function () {
        $('#side_menu li').removeClass('active');
        $('.feed').addClass('view');
      })
    });
    timer(1000, 2000).subscribe(i => {
      this.currentBuildingMaintenanceActive = localStorage.getItem('currentBuildingMaintenanceActive') == 'true';
    });
    this.link.currentMessage1.subscribe((res) => {
      // console.log(res);

      if (res == '/feed') {
        $('#side_menu li').removeClass('view');
        $('.feed').addClass('view');
      } else if (res == '/buildings') {
        $('#side_menu li').removeClass('view');
        $('.building').addClass('view');
      } else if (res == '/residents') {

        $('#side_menu li').removeClass('view');
        $('.resi').addClass('view');
      } else if (res == '/documents') {
        this.docuTrue = 'true';
        $('#side_menu li').removeClass('view');
        $('.docu').addClass('view');
      } else if (res == '/buildings/alerts') {
        this.alertTrue = 'true'
        $('#side_menu li').removeClass('view');
        $('.alrt').addClass('view');
      } else if (res == '/messages') {
        $('#side_menu li').removeClass('view');
        $('.msg').addClass('view');
      } else if (res == '/allgroups') {
        $('#side_menu li').removeClass('view');
        $('.grp').addClass('view');
      } else if (res == '/user/settings/account' || res == '/user/settings/notifications' || res == '/user/settings/payment') {
        $('#side_menu li').removeClass('view');
      }
    });

    this.buildingService.getAllUnreadAlerts(this.id, this.userBuildingId).subscribe(
      (data) => {
        // console.log('Unread Alerts : ', data);
        var tempAlert = [];
        for (let alert of data.alerts) {
          if (alert.readBy.length <= 0 && alert.building.length > 0) {
            tempAlert.push(alert);
          }
        }
        // console.log('Old unread alert value: ', this.oldUnreadAlert);
        // console.log('Unread: ', tempAlert.length);
        if (tempAlert.length > this.oldUnreadAlert) {
          this.unreadAlert = tempAlert.length;
        }
        this.oldUnreadAlert = tempAlert.length;
      }
    );

    if (this.isManager === 'true') {
      this.buildingAlertLink = '/buildings/alerts';
    } else {
      // this.ngZone.runOutsideAngular(() => {
      //   this.timer = Observable.timer(1000, 30000)
      //     .subscribe(i => this.ngZone.run(() => {

      // Is logged in check
      /*this.httpService.isAuthenticated().subscribe((res: any)=>{
        if(!res.authenticated){
          localStorage.clear();
          this.router.navigate(['/']);
        }
      });*/

      // Check building manager exists
      if (this.isManager != 'true') {
        this.userService.isManagerExists(this.userBuildingId).subscribe(
          (building: any) => {
            // console.log('Is Building Manager Exists : ', building);
            var buildingManager = (building.building[0]) ? building.building[0].buildingManager : '';
            var resident = building.building[0].resident;
            if (_.isEmpty(buildingManager) || _.isUndefined(buildingManager)) {
              this.buildingAlertLink = '';
            } else {
              this.buildingAlertLink = '/buildings/alerts';
            }
          }
        );
      }
      //}));
      //});
    }

    this.eventService.eventEmit$
      .subscribe(event => {
        // console.log('Event', event.removeGroup, event);
        if (event.replaceBuildingByRes) {
          this.httpService.isManagerExist(this.id).subscribe(
            (res) => {
              this.isManagerStatus = false;
            },
            (error) => {
              this.isManagerStatus = true;
            });
        }

        if (event.groupReset) {
          if (event.isLeave_group) {
            this.groupList = this.groupList.filter(e => e.id !== event.group_id);
          }
          if (event.clearAllGroups) {
            this.groupList = [];
            this.allGroups = [];
          }
          this.getMyGroups()
          this.getAllGroups();
        }
        if (event.removeGroup) {
          this.getMyGroups()
          this.getAllGroups();
        }
      });

    this.eventService._msgCount$
      .subscribe(event => {

        if (event['getAllMsgCount'] >= 0) {
          this.totalMsg = event['getAllMsgCount'];
        }
        if (event['getAllGroupsCount'] >= 0) {
          this.totalGroups = event['getAllGroupsCount'];
        }
      });


    this.getMyGroups()
    this.getAllGroups();
  }

  ngAfterViewInit() {

    // setTimeout(() => {
    //   this.httpService.isManagerExist(this.id).subscribe(
    //     (res)=>{
    //       console.log('step1', res);
    //   this.isManagerStatus = false;
    //   },
    //     (error)=>{
    //       this.isManagerStatus = true;
    //   })
    // }, 2000);
  }

  resetUnreadAlert() {

    if (this.isManager !== 'true' && this.userType !== 'admin' && !this.isManagerStatus) {
      return;
    }

    this.router.navigate(['/buildings', 'alerts'])
    setTimeout(() => {
      this.unreadAlert = 0;
      this.oldUnreadAlert = 0;
      this.alertList = []
    }, 1000)
    this.eventService.alert$.next('reset');
  }

  showSideMenu() {
    if (($(window).innerWidth() > 991) && (!$('body').hasClass("firstTime"))) {
      $('.main_container #sidepanel_id').removeClass('menu_text_hidden');
    }
  }

  feedFilter(type, clicked = null) {
    if (this.currentBuildingMaintenanceActive == false && type == 'maintenance' && !this.isManagerStatus) {
      return false;
    } else if (!this.isManagerStatus && (type === 'flagged Posts' || type === 'maintenance')) {
      return false;
    }
    $('#side_menu li').removeClass('view');
    $(clicked).addClass('view');
    // console.log(clicked)
    let link = this.router.url;
    var arr = link.split('/');
    this.eventService.eventEmit$.next({postType: type});
    // if(arr[arr.length - 1] === 'feed'){
    //   this.eventService.eventEmit$.next({postType: type});
    // }else{
    //   this.router.navigate(['/feed']);
    //   this.eventService.eventEmit$.next({postType: type});
    // }
    // if(arr[arr.length - 1] != 'feed'){
    //   if(type === 'All'){
    //     this.router.navigate(['/feed'])
    //     this.eventService.eventEmit$.next({postType: type});
    //   }else{
    //     this.router.navigate(['/feed'], { queryParams: { activeClass: type}});
    //     this.eventService.eventEmit$.next({postType: type});
    //   }
    // }
    this.postFilter.changeMessage(type);
  }

  hideSideMenu() {
    if (($(window).innerWidth() > 991) && (!$('body').hasClass("firstTime"))) {
      $('.main_container #sidepanel_id').addClass('menu_text_hidden');
    }
  }

  mobileFullMenu(type = null) {

    if (type === 'flag' && !this.isManagerStatus) {
      return false;
    }

    $('body').find('#bottomMenu div.active').removeClass('active');
    switch (type) {
      case 'post':
        $('body').find('#bottomMenu div.activity').addClass('active')
        break;
      case 'maint' :
        $('body').find('#bottomMenu div.maintenance').addClass('active')
        break;
      case 'msg' :
        $('body').find('#bottomMenu .messages').addClass('active')
        break;
      case 'alert' :
        $('body').find('#bottomMenu .notification').addClass('active')
        break;
      default :
        break;
    }
    if ($(window).innerWidth() < 481) {
      if (($('.main_container .side_panel').css('left')) == '-200px') {
        $('.main_container .side_panel').css({'left': 0, 'width': '100%'});
        $('#mobile_menu_switch1').addClass('view');
      } else {
        $('.main_container .side_panel').css({'left': '-200px', 'width': '200px'});
        $('#mobile_menu_switch1').removeClass('view');
      }
    }
  }

  getMyGroups() {
    this.groupList = [];
    this._groupService.getAllGroups().subscribe((res) => {

      res.forEach((building) => {
        building.allGroups.forEach((group) => {
          this.groupList.push(group);
        });
      });
      this.groupList = this.groupList.filter((v, i, a) => i === a.findIndex((t) => (
        t.id === v.id)));

      this.groupList.sort(function (date1, date2) {
        var c = new Date(date1.updatedAt);
        var d = new Date(date2.updatedAt);
        if (c > d) return -1;
        if (c < d) return 1;
        return 0;
      });

      this.groupList = this.groupList.filter((e, i) => {
        if (i <= 4) return true

        else return false;
      });

    });
  }

  getAllGroups() {
    this.allGroups = [];
    this._groupService.getGroups().subscribe((res) => {
      res.forEach((building) => {
        building.allGroups.forEach((group) => {
          this.allGroups.push(group);
        });
      });
      this.allGroups = this.allGroups.filter((v, i, a) => i === a.findIndex((t) => (
        t.id === v.id)));


      this.allGroups.sort(function (date1, date2) {
        var c = new Date(date1.updatedAt);
        var d = new Date(date2.updatedAt);
        if (c > d) return -1;
        if (c < d) return 1;
        return 0;
      });

      this.allGroups = this.allGroups.filter((e, i) => {
        if (i <= 4) return true

        else return false;
      });

    });

  }

  joinGroup(group) {
    this.allGroups = this.allGroups.filter(e => e.id !== group.id);
    this._groupService.joinGroup({groupId: group.id}).subscribe((res) => {
      this.getMyGroups();
      this.getAllGroups()
    })
  }

  leaveGroup(group) {

    // this.leavingGroupName = group;

    // $('#confirm_modal1').modal('show');

    // var that = this;
    // $('#confirm_modal1').on('hidden.bs.modal', function () {
    //   that.leavingGroupName = null;
    // })

    this.groupList = this.groupList.filter(e => e.id !== group.id);

    this._groupService.leaveGroup({groupId: group.id}).subscribe((res) => {
      this.getMyGroups();
      this.getAllGroups()

    });

  }

  confirmLeaveGroup() {

    // if(this.leavingGroupName){
    //    this.groupList = this.groupList.filter(e=>e.id !==  this.leavingGroupName.id);

    //     this._groupService.leaveGroup({ groupId: this.leavingGroupName.id }).subscribe((res) => {
    //       this.getMyGroups();
    //       this.getAllGroups()
    //       $('#confirm_modal1').modal('hide');
    //       this.leavingGroupName = null;
    //     });
    // }

  }
  openGroup(group) {
    this.router.navigate(['groups'], {queryParams : {opengroup : group.id, name : group.name }});
  }

}
